import { useToastManager } from "@porsche-design-system/components-react"
import type { RoofColorView } from "@slfinrtl/ui-bff-routes"
import { useContext, useState } from "react"
import { defineMessages, useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import type { OrderType } from "../OrderType"
import { SelectCatalogRoofColorContainer } from "./catalog/SelectCatalogRoofColorContainer"
import { CustomRoofColorContainer } from "./custom/CustomRoofColorContainer"

const messages = defineMessages({
	selectRoofColor: {
		defaultMessage: "Select roof color",
		id: "colors.roofColor.selectRoofColor",
	},
})

export interface SelectRoofColorModalProps {
	inventoryId: string
	orderType: OrderType
	roofColor: RoofColorView | undefined
	setRoofColor: (roofColor: RoofColorView) => void
}

type RoofColorModalState = "catalog" | "custom"

export const SelectRoofColorModal = ({
	id,
	modalProps: { inventoryId, orderType, roofColor, setRoofColor },
}: ModalProps<SelectRoofColorModalProps>) => {
	const { formatMessage } = useIntl()
	const { hideModal } = useContext(ModalContext)
	const [state, setState] = useState<RoofColorModalState>(!roofColor || roofColor.optionCode ? "catalog" : "custom")
	const { addMessage } = useToastManager()
	return (
		<Modal id={id} width="wide" heading={formatMessage(messages.selectRoofColor)}>
			{state === "catalog" ? (
				<SelectCatalogRoofColorContainer
					orderType={orderType}
					inventoryId={inventoryId}
					currentRoofColor={roofColor}
					onRoofColorSelected={(selectedRoofColor) => {
						hideModal(id)
						setRoofColor(selectedRoofColor)
						addMessage({
							state: "success",
							text: formatMessage(commonMessages.saveSuccess),
						})
					}}
					showCustomRoofColorContainer={() => setState("custom")}
				/>
			) : (
				<CustomRoofColorContainer
					currentRoofColor={roofColor}
					inventoryId={inventoryId}
					onRoofColorCreated={(createdRoofColor) => {
						hideModal(id)
						setRoofColor(createdRoofColor)
						addMessage({
							state: "success",
							text: formatMessage(commonMessages.saveSuccess),
						})
					}}
					showCatalogRoofColorContainer={() => setState("catalog")}
				/>
			)}
		</Modal>
	)
}
